import {MouseEvent, useEffect} from "react";
import {css} from "@panda/css";

import {HeartIcon} from "@pg-design/icons-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {NAVIGATION_MOBILE_TEST_IDS, NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {useKMLink} from "../../hooks/use_km_link";
import {useAppSelector} from "../../store/hooks";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {useFavoritesAuth} from "../hooks/use_favorites_auth";
import {trackFavouritesIconClick} from "../tracking/track_favourites_icon_click";
import {getFavouritesTopbarCards, IFavouriteTopbarSource} from "../utils/map_favourite_to_topbar_card";
import {consumePendingFavouritesTopbar, redirectToFavouritesList, setPendingFavouritesTopbar} from "../utils/pending_favourites_auth";
import {FavouritesCountBadge} from "./FavouritesCountBadge";
import {FavouritesTopbarDesktop} from "./FavouritesTopbarDesktop";

interface IProps {
    slot?: "desktop" | "mobile";
    variant: "desktop" | "mobile";
}

export const FavouritesTopbar = (props: IProps) => {
    const {variant, slot = variant} = props;
    const favourites = useAppSelector((state) => state.favourite.favourites);
    const favouritesListLink = useKMLink(kmAppLink.site.offers.favouritesWithParams);
    const isAuthenticated = useIsAuthenticated();
    const viewType = useAppSelector((state) => state.viewType.current);
    const favoritesAuth = useFavoritesAuth();
    const storedCount = favourites.properties.length + favourites.offers.length;
    const count = storedCount > 0 ? storedCount : favourites.list.length;
    const cards = getFavouritesTopbarCards(favourites.list as IFavouriteTopbarSource[]);
    const showBadge = isAuthenticated && count > 0;
    const favouriteLabel = showBadge ? `Ulubione, ${count}` : "Ulubione";
    const isMobileSlot = slot === "mobile";
    const badgeTestId = isMobileSlot ? NAVIGATION_MOBILE_TEST_IDS.FAVOURITES.BADGE : NAVIGATION_TEST_IDS.FAVOURITES.BADGE;
    const buttonTestId = isMobileSlot ? NAVIGATION_MOBILE_TEST_IDS.FAVOURITES.BUTTON : NAVIGATION_TEST_IDS.FAVOURITES.BUTTON;

    const openFavouritesAuth = (pendingVariant: "desktop" | "mobile") => {
        setPendingFavouritesTopbar(pendingVariant);
        favoritesAuth({
            type: "property",
            amplitudePlacement: "rp_favourites"
        });
    };

    useEffect(() => {
        if (variant !== "mobile" || !isAuthenticated) {
            return;
        }

        if (!consumePendingFavouritesTopbar("mobile")) {
            return;
        }

        redirectToFavouritesList(favouritesListLink);
    }, [favouritesListLink, isAuthenticated, variant]);

    if (variant === "mobile") {
        return (
            <a
                aria-label={favouriteLabel}
                className={mobileButtonStyle}
                data-testid={buttonTestId}
                href={favouritesListLink}
                onClick={(event: MouseEvent<HTMLAnchorElement>) => {
                    trackFavouritesIconClick();

                    if (isAuthenticated) {
                        return;
                    }

                    event.preventDefault();
                    openFavouritesAuth("mobile");
                }}
            >
                <span className={mobileIconWrapStyle}>
                    <HeartIcon fill="var(--colors-gray-800)" size="2.4" />
                    {showBadge && <FavouritesCountBadge className={mobileBadgeStyle} count={count} dataTestId={badgeTestId} />}
                </span>
            </a>
        );
    }

    return (
        <FavouritesTopbarDesktop
            badgeTestId={badgeTestId}
            buttonTestId={buttonTestId}
            count={count}
            favouriteLabel={favouriteLabel}
            favouritesListLink={favouritesListLink}
            isAuthenticated={isAuthenticated}
            onGuestClick={() => openFavouritesAuth("desktop")}
            cards={cards}
            showBadge={showBadge}
            viewType={viewType}
        />
    );
};

const mobileButtonStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "3.6rem",
    h: "6rem",
    mr: 0.5
});

const mobileIconWrapStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "3.6rem",
    h: "3.6rem",
    bg: "var(--colors-beige-subtle)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: "50%"
});

const mobileBadgeStyle = css({
    top: "-6px",
    right: "-6px",
    left: "auto"
});
import {MouseEvent, useEffect} from "react";
import {css} from "@panda/css";

import {HeartIcon} from "@pg-design/icons-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {NAVIGATION_MOBILE_TEST_IDS, NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {useKMLink} from "../../hooks/use_km_link";
import {useAppSelector} from "../../store/hooks";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {useFavoritesAuth} from "../hooks/use_favorites_auth";
import {trackFavouritesIconClick} from "../tracking/track_favourites_icon_click";
import {getFavouritesTopbarCards, IFavouriteTopbarSource} from "../utils/map_favourite_to_topbar_card";
import {consumePendingFavouritesTopbar, redirectToFavouritesList, setPendingFavouritesTopbar} from "../utils/pending_favourites_auth";
import {FavouritesCountBadge} from "./FavouritesCountBadge";
import {FavouritesTopbarDesktop} from "./FavouritesTopbarDesktop";

interface IProps {
    slot?: "desktop" | "mobile";
    variant: "desktop" | "mobile";
}

export const FavouritesTopbar = (props: IProps) => {
    const {variant, slot = variant} = props;
    const favourites = useAppSelector((state) => state.favourite.favourites);
    const favouritesListLink = useKMLink(kmAppLink.site.offers.favouritesWithParams);
    const isAuthenticated = useIsAuthenticated();
    const viewType = useAppSelector((state) => state.viewType.current);
    const favoritesAuth = useFavoritesAuth();
    const storedCount = favourites.properties.length + favourites.offers.length;
    const count = storedCount > 0 ? storedCount : favourites.list.length;
    const cards = getFavouritesTopbarCards(favourites.list as IFavouriteTopbarSource[]);
    const showBadge = isAuthenticated && count > 0;
    const favouriteLabel = showBadge ? `Ulubione, ${count}` : "Ulubione";
    const isMobileSlot = slot === "mobile";
    const badgeTestId = isMobileSlot ? NAVIGATION_MOBILE_TEST_IDS.FAVOURITES.BADGE : NAVIGATION_TEST_IDS.FAVOURITES.BADGE;
    const buttonTestId = isMobileSlot ? NAVIGATION_MOBILE_TEST_IDS.FAVOURITES.BUTTON : NAVIGATION_TEST_IDS.FAVOURITES.BUTTON;

    const openFavouritesAuth = (pendingVariant: "desktop" | "mobile") => {
        setPendingFavouritesTopbar(pendingVariant);
        favoritesAuth({
            type: "property",
            amplitudePlacement: "rp_favourites"
        });
    };

    useEffect(() => {
        if (variant !== "mobile" || !isAuthenticated) {
            return;
        }

        if (!consumePendingFavouritesTopbar("mobile")) {
            return;
        }

        redirectToFavouritesList(favouritesListLink);
    }, [favouritesListLink, isAuthenticated, variant]);

    if (variant === "mobile") {
        return (
            <a
                aria-label={favouriteLabel}
                className={mobileButtonStyle}
                data-testid={buttonTestId}
                href={favouritesListLink}
                onClick={(event: MouseEvent<HTMLAnchorElement>) => {
                    trackFavouritesIconClick();

                    if (isAuthenticated) {
                        return;
                    }

                    event.preventDefault();
                    openFavouritesAuth("mobile");
                }}
            >
                <span className={mobileIconWrapStyle}>
                    <HeartIcon fill="var(--colors-gray-800)" size="2.4" />
                    {showBadge && <FavouritesCountBadge className={mobileBadgeStyle} count={count} dataTestId={badgeTestId} />}
                </span>
            </a>
        );
    }

    return (
        <FavouritesTopbarDesktop
            badgeTestId={badgeTestId}
            buttonTestId={buttonTestId}
            count={count}
            favouriteLabel={favouriteLabel}
            favouritesListLink={favouritesListLink}
            isAuthenticated={isAuthenticated}
            onGuestClick={() => openFavouritesAuth("desktop")}
            cards={cards}
            showBadge={showBadge}
            viewType={viewType}
        />
    );
};

const mobileButtonStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "3.6rem",
    h: "6rem",
    mr: 0.5
});

const mobileIconWrapStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "3.6rem",
    h: "3.6rem",
    bg: "var(--colors-beige-subtle)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: "50%"
});

const mobileBadgeStyle = css({
    top: "-6px",
    right: "-6px",
    left: "auto"
});
